<template>
  <span class="switcher relative inline-flex items-center">
    <ui-switch
      :model-value="!!modelValue"
      :disabled="disabled || loading"
      :class="[ TONE_CLASSES[tone], inverted && INVERTED_CLASSES, loading && 'opacity-0' ]"
      @update:model-value="(value) => $emit('update:modelValue', value)"
    />
    <loader-circle-icon
      v-if="loading"
      :class="[ 'absolute inset-0 m-auto size-4 animate-spin', inverted ? 'text-white' : 'text-primary' ]"
    />
  </span>
</template>

<script>
import { LoaderCircle } from '@lucide/vue';

// Rule action colors (8ad $pink / $orange), used by the automation list.
const TONE_CLASSES = {
  primary: '',
  pink: 'data-[state=checked]:bg-[#FE02BB]',
  orange: 'data-[state=checked]:bg-[#FE7002]',
};

// White switch for colored card headers.
const INVERTED_CLASSES = 'data-[state=checked]:bg-white data-[state=unchecked]:bg-white/40 [&_[data-slot=switch-thumb]]:bg-primary';

/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'Switcher',
  components: {
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    modelValue: {
      type: [ Boolean, String, Number ],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tone: {
      type: String,
      default: 'primary',
      validator: value => Object.keys(TONE_CLASSES).includes(value),
    },
    inverted: {
      type: Boolean,
      default: false,
    },
  },
  emits: [ 'update:modelValue' ],
  data: () => ({
    TONE_CLASSES,
    INVERTED_CLASSES,
  }),
};
</script>
